<template>
  <div class="app-container">
    <div class="form-container">
      <div class="text-xl font-bold uppercase mb-8">
        <h1>Edit User Detail</h1>
      </div>
      <el-form :model="editUserForm" :rules="editUserFormRules" ref="form">
        <el-form-item
          class="font-medium text-primary-400"
          label="Email Id"
          prop="username"
        >
          <el-input style="margin-left: 78px;" v-model="editUserForm.emailId" placeholder="Enter your email" />
        </el-form-item>
        <el-form-item
          class="font-medium text-primary-400"
          label="First Name"
          prop="firstName"
        >
          <el-input style="margin-left: 60px;" v-model="editUserForm.firstName" placeholder="Enter your first name" />
        </el-form-item>
        <el-form-item
          class="font-medium text-primary-400"
          label="Last Name"
          prop="lastName"
        >
          <el-input  style="margin-left: 62px;" v-model="editUserForm.lastName" placeholder="Enter your last name" />
        </el-form-item>
        <el-form-item
          class="font-medium text-primary-400"
          label="Customer (User ID)"
          prop="CustomerUserId"
        >
          <el-input style="margin-left: 10px;" v-model="editUserForm.customerId" placeholder="Enter customer user ID" />
        </el-form-item>
        <el-form-item
          class="font-medium text-primary-400"
          label="Mobile Number"
          prop="mobileNumber"
        >
          <el-input
            style="margin-left: 31px;"
            v-model="editUserForm.mobilrNum"
            type="number"
            placeholder="Enter mobile number"
          />
        </el-form-item>
        <el-form-item
          class="font-medium text-primary-400"
          label="Enabled Access Type"
          prop="enabledAccessType"
        >
          <el-select
          style="margin-left: 1px;"
            v-model="daysType"
            size="mini"
            placeholder="Select Day Range"
            @change="onChangeDaysValue"
          >
            <el-option value="months" label="Any"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="font-medium text-primary-400"
          label="Role"
          prop="role"
        >
          <div style="margin-left:110px">
            <el-checkbox v-model="checked1" label="internal" size="large" />
            <el-checkbox v-model="checked2" label="manager" size="large" />
          </div>
        </el-form-item>
        <el-form-item
          class="font-medium text-primary-400"
          label="Reset Password"
          prop="resetPassword"
        >
          <el-input
          style="margin-left: 32px;"
            v-model="editUserForm.password"
            type="password"
            placeholder="Reset your password"
          />
        </el-form-item>
          <el-button
            style="background-color: #0c5c6d; color:#eeeeee;padding: 20px 20px"
            class="text-600 ml-32 w-32"
            @click="saveAddUserForm"
          >
            Save
          </el-button>
          <el-button
          style="background-color:#f47067; color:#eeeeee;padding: 20px 20px"
          class="text-600 ml-32 w-32"
          @click="cancelEditForm"
        >
          Cancel
        </el-button>
      </el-form>
    </div>
    
  </div>
</template>

<script>
import editUserDetail from './editUserDetail';
export default editUserDetail;
</script>

<style scoped>
.app-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f6f3f3;
  background-size: cover;
  background-position: center;
}

.form-container {
  background-color: white;
  padding: 15px;
  height: 550px;
  border-radius: 5px;
  box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.1);
  width: 500px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.buttonContainer {
  display: flex;
  gap: 10px;
}

.el-form-item {
  margin-bottom: 20px;
}

@media (max-width: 600px) {
  .form-container {
    width: 90%;
  }
}
</style>
